import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";

// Importing all module reducers
import authReducer from "../modules/auth/reducer";
import tableReducer from "../core/modules/table/reducer";
import hop from "../core/modules/hop/reducer";
import srReducer from "../modules/serviceRequest/reducer";
import { LOG_OUT } from "../modules/auth/actionTypes";
import commonReducer from "./commonReducer";

const reducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  tableList: tableReducer,
  hop: hop,
  serviceRequest: srReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const appReducer = (state, action) => {
  if (action.type === LOG_OUT) {
    state = undefined;
  }
  return reducer(state, action);
};

const store = createStore(appReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
